

































import { Component, Mixins, } from "vue-property-decorator";
import { DialogMixin } from "../../../system/mixins";
import { IAiPhraseRecord, IAiPhraseRecordInformation, IAiPhraseAuthor } from "../../../../domain/externalSystem";
import { AiPhraseRecordViewer, AiPhraseRecordFilter } from "./contents";
import { RecordFilter } from "./contents/model";

@Component({
  components: {
    AiPhraseRecordViewer,
    AiPhraseRecordFilter,
  }
})
export default class AiMedicalRecordsViewDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      records: [],
      conditions: "",
      evidences: [],
      recordFilter: {
        value: "",
        isImportant: undefined,
        author: "",
        department: "",
        createdAtFrom: null,
        createdAtTo: null,
      },
    };
  }
  records: IAiPhraseRecord[];
  conditions: string;
  evidences: IAiPhraseRecord[];
  recordFilter: RecordFilter;

  get title(): string {
    return "診療録一覧(" + this.records.length + "件)";
  }

  get hasEvidences(): boolean {
    return this.evidences && this.evidences.length > 0;
  }

  get recordInformation(): IAiPhraseRecordInformation[] {
    return this.records
      .map(r => ({ source: r, isImportant: this.isImportantRecord(r)}));
  }

  get filteredInformation(): IAiPhraseRecordInformation[] {
    if (!this.recordFilter) { return this.recordInformation; }
    return this.recordInformation.filter(i => this.isMatch(i));
  }

  isMatch(record: IAiPhraseRecordInformation): boolean {
    const recordSource = record.source;
    const recordDate = recordSource.at ? this.toDate(recordSource.at) : null;
    return (
      (!this.recordFilter.createdAtFrom || (!!recordDate && recordDate >= this.recordFilter.createdAtFrom)) &&
      (!this.recordFilter.createdAtTo || (!!recordDate && recordDate <= this.recordFilter.createdAtTo)) &&
      (this.recordFilter.isImportant === undefined || record.isImportant === this.recordFilter.isImportant) &&
      (!this.recordFilter.author || ((recordSource.author && recordSource.author.name) ? recordSource.author.name.includes(this.recordFilter.author) : false)) &&
      (!this.recordFilter.department || (recordSource.department ? recordSource.department.includes(this.recordFilter.department) : false)) &&
      (!this.recordFilter.value || (recordSource.description ? recordSource.description.includes(this.recordFilter.value) : false))
    );
  }

  isImportantRecord(source: IAiPhraseRecord): boolean {
    return !!this.evidences.find(e =>
      this.areDatesEqual(e.at, source.at)
      && this.areAuthorsEqual(e.author, source.author)
      && e.department === source.department
      && e.description === source.description
      && e.source === source.source
    );
  }

  areDatesEqual(source: Date, destination: Date): boolean {
    return (!source && !destination)
      || ((source && destination) && (source.getTime() === destination.getTime()));
  }

  areAuthorsEqual(source: IAiPhraseAuthor, destination: IAiPhraseAuthor): boolean {
    return (!source && !destination)
      || (source.name === destination.name && source.role === destination.role);
  }

  toDate(source: Date): Date {
    return new Date(
      source.getFullYear(),
      source.getMonth(),
      source.getDate()
    );
  }

  async show(records: IAiPhraseRecord[], conditions: string, evidences: IAiPhraseRecord[]): Promise<void> {
    return this.showModal(async () => {
      this.records = records;
      this.conditions = conditions;
      this.evidences = evidences;
      await this.waitHidden();
    });
  }

  close(): void {
    this.isVisible = false;
  }
}
